export const capUnseen = (unseen: number) => {
  if (unseen > 99) {
    return "99+";
  }
  return unseen;
};
